import React, { type ReactNode } from 'react';
import { Pressable } from 'react-native';
import {
  ColorValues,
  Typography,
  IconClose,
  Flex,
  SafeAreaBottomSpacing,
  useScreenSize,
} from '@banhala/ui-kit';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const BottomSheetContainer: React.FC<{
  onPressClose?: () => void;
  hideBorder?: boolean;
  children: ReactNode;
}> = props => {
  const { width } = useScreenSize();
  const { top } = useSafeAreaInsets();
  return (
    <Flex
      width={width}
      maxWidth={600}
      padding={{ top }}
      margin={{
        horizontal: 'auto',
      }}
      flex={1}
      backgroundColor={'white'}
    >
      <Flex.Column
        position="relative"
        alignItems={'center'}
        justifyContent="center"
        padding={{
          vertical: 10,
          horizontal: 16,
        }}
      >
        <Pressable
          testID="모달닫기버튼"
          onPress={props.onPressClose}
          style={{
            position: 'absolute',
            right: 16,
            cursor: 'pointer',
          }}
        >
          <IconClose fill={ColorValues.gray60} width={24} height={24} />
        </Pressable>
        <Typography type="h5" color="content_primary">
          필터
        </Typography>
      </Flex.Column>

      {props.children}

      <SafeAreaBottomSpacing />
    </Flex>
  );
};
